var _defs, _path, _g, _path2, _text;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgPdf = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 270,
  height: 155
}, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "pdf_svg__a"
}, /*#__PURE__*/React.createElement("path", {
  fill: "none",
  d: "M0 0h121v120.999H0z",
  "data-name": "Rectangle 128"
})))), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#f5f5f5",
  d: "M0 0h270v155H0z",
  "data-name": "Rectangle 18391"
})), _g || (_g = /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 644106"
}, /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#pdf_svg__a)",
  "data-name": "Group 233",
  transform: "translate(74.5 17)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  fillRule: "evenodd",
  d: "M120.5 60.5a60 60 0 1 1-60-60 60 60 0 0 1 60 60",
  "data-name": "Path 2870"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#bcc1c9",
  d: "M60.5 121a60.22 60.22 0 0 1-33.827-10.332A60.67 60.67 0 0 1 4.755 84.049a60.42 60.42 0 0 1 5.578-57.375A60.68 60.68 0 0 1 36.951 4.755a60.42 60.42 0 0 1 57.376 5.578 60.67 60.67 0 0 1 21.918 26.617 60.42 60.42 0 0 1-5.578 57.375 60.67 60.67 0 0 1-26.617 21.92A60.1 60.1 0 0 1 60.5 121m0-120a59.22 59.22 0 0 0-33.266 10.162A59.67 59.67 0 0 0 5.676 37.34a59.42 59.42 0 0 0 5.486 56.426 59.68 59.68 0 0 0 26.179 21.557 59.42 59.42 0 0 0 56.427-5.486 59.67 59.67 0 0 0 21.557-26.177 59.42 59.42 0 0 0-5.486-56.426A59.67 59.67 0 0 0 83.661 5.676 59.1 59.1 0 0 0 60.5 1",
  "data-name": "Path 2871"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#353c3c",
  d: "M79.619 88.9H37.268a5.044 5.044 0 0 1-4.93-4.93V41.624h1.7V83.94A3.346 3.346 0 0 0 37.3 87.2h42.321Zm4.1-8.676h-.01l-38.254-.007a5.043 5.043 0 0 1-4.93-4.93V37.025a5.043 5.043 0 0 1 4.93-4.93h38.278a5.044 5.044 0 0 1 4.93 4.93V75.3a5.044 5.044 0 0 1-4.93 4.93ZM45.49 78.522l38.213.007a3.346 3.346 0 0 0 3.261-3.261V37.056a3.346 3.346 0 0 0-3.264-3.261H45.49a3.345 3.345 0 0 0-3.261 3.26v38.207a3.345 3.345 0 0 0 3.261 3.26",
  "data-name": "Path 2872"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#62061f",
  d: "M53.214 51.092a6.7 6.7 0 0 1 2.011.271 3.9 3.9 0 0 1 1.407.761 3.04 3.04 0 0 1 .827 1.177 4.35 4.35 0 0 1-.017 3.068 3.25 3.25 0 0 1-.855 1.209 4 4 0 0 1-1.411.79 6.2 6.2 0 0 1-1.962.284h-1.76v4.286h-1.926V51.092Zm0 6.038a3.6 3.6 0 0 0 1.131-.164 2.2 2.2 0 0 0 .814-.465 1.9 1.9 0 0 0 .49-.728 2.7 2.7 0 0 0 .165-.955 2.5 2.5 0 0 0-.161-.929 1.8 1.8 0 0 0-.481-.7 2.1 2.1 0 0 0-.81-.44 3.9 3.9 0 0 0-1.148-.153h-1.76v4.534Z",
  "data-name": "Path 2873"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#62061f",
  d: "M69.97 57.014a6.5 6.5 0 0 1-.428 2.406 5.3 5.3 0 0 1-3.072 3.085 6.5 6.5 0 0 1-2.422.432h-4.476V51.091h4.476a6.5 6.5 0 0 1 2.422.432 5.3 5.3 0 0 1 3.072 3.085 6.5 6.5 0 0 1 .428 2.406m-1.965 0a5.7 5.7 0 0 0-.276-1.834 3.8 3.8 0 0 0-.79-1.374 3.45 3.45 0 0 0-1.247-.86 4.3 4.3 0 0 0-1.644-.3h-2.542v8.736h2.542a4.3 4.3 0 0 0 1.644-.3 3.4 3.4 0 0 0 1.247-.86 3.85 3.85 0 0 0 .79-1.373A5.7 5.7 0 0 0 68 57.014",
  "data-name": "Path 2874"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#62061f",
  d: "M74.018 52.646v3.792h4.631v1.555h-4.631v4.944h-1.933V51.091h7.387v1.555Z",
  "data-name": "Path 2875"
})))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#772432",
  d: "M196 0h74v31h-74z",
  "data-name": "Rectangle 18395"
})), _text || (_text = /*#__PURE__*/React.createElement("text", {
  fill: "#fff",
  fontFamily: "Lato-Bold, Lato",
  fontSize: 14,
  fontWeight: 700,
  transform: "translate(233 21)"
}, /*#__PURE__*/React.createElement("tspan", {
  x: -13.538,
  y: 0
}, "PDF"))));
export { SvgPdf as ReactComponent };
export default __webpack_public_path__ + "2e8ab6f8a4ebabc5be9141e63b9095e4.svg";